"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {[1, 2, 3].map(i => <div key={i} data-index={i} className="space-y-3">
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
            <div className="h-4 w-32 bg-muted animate-pulse rounded-md" />
            <div className="h-4 w-28 bg-muted animate-pulse rounded-md" />
          </div>)}
      </div>;
  }
  const itemsPerColumn = Math.ceil(menuItems.length / 3);
  const columns = [menuItems.slice(0, itemsPerColumn), menuItems.slice(itemsPerColumn, itemsPerColumn * 2), menuItems.slice(itemsPerColumn * 2)];
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {columns.map((column, colIndex) => <NavigationMenu key={colIndex} data-index={colIndex} viewport={false}>
          <NavigationMenuList className="flex-col items-start space-y-2">
            {column.map(item => <NavigationMenuItem key={item.id}>
                <NavigationMenuLink asChild>
                  <Link to={item.href || "#"} className="text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-150 text-sm py-2 px-0 block min-h-[44px] min-w-[44px] flex items-center">
                    {item.label}
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>)}
          </NavigationMenuList>
        </NavigationMenu>)}
    </div>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }];
  return <footer id="footer" className="bg-dark-background text-foreground-dark py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <MenuProvider menu_id="4">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        <div className="flex justify-end mb-8">
          <div className="flex gap-4">
            {socialLinks.map((social, index) => {
            const Icon = social.icon;
            return <Link key={index} data-index={index} to={social.href} newTab aria-label={social.label} className="w-11 h-11 flex items-center justify-center rounded-full border border-foreground-dark/30 text-foreground-dark/70 hover:text-foreground-dark hover:border-foreground-dark transition-all duration-150">
                  <Icon className="w-5 h-5" />
                </Link>;
          })}
          </div>
        </div>

        <Separator className="bg-foreground-dark/20 mb-6" />

        <div className="text-center">
          <p className="text-foreground-dark/60 text-xs leading-relaxed max-w-3xl mx-auto">
            Administrative services only. All clinical responsibility remains with the provider.
          </p>
        </div>
      </div>
    </footer>;
}